import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

interface BatchAnimationConfig {
  selector: string | Element[];
  initialState: gsap.TweenVars;
  resetState?: gsap.TweenVars;
  checkVisited?: boolean;
  stagger?: number;
}

export const createBatchAnimation = ({
  selector,
  initialState,
  resetState,
  checkVisited = false,
  stagger = 0.15,
}: BatchAnimationConfig): ScrollTrigger[] => {
  const enterStagger = stagger;
  const backStagger = 0.05;
  const backNewStagger = stagger;

  const finalResetState = resetState || initialState;

  // const batchVarsWithMarkers = { markers: {startColor: "green", endColor: "red", fontSize: "18px", fontWeight: "bold", indent: 20} } as any;
  gsap.set(selector, initialState);

  return ScrollTrigger.batch(selector, {
    // ...batchVarsWithMarkers,
    start: 'top bottom',
    end: 'bottom top',
    invalidateOnRefresh: true,
    onEnter: (batch) => {
      if (!checkVisited) {
        gsap.to(batch, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 1,
          stagger: enterStagger,
          overwrite: true,
        });
        return;
      }

      const newItems: Element[] = [];
      const oldItems: Element[] = [];
      batch.forEach((el) => {
        if ((el as HTMLElement).dataset.animated) {
          oldItems.push(el);
        } else {
          newItems.push(el);
          (el as HTMLElement).dataset.animated = 'true';
        }
      });

      if (newItems.length > 0) {
        gsap.to(newItems, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 1,
          stagger: enterStagger,
          overwrite: true,
        });
      }

      if (oldItems.length > 0) {
        gsap.to(oldItems, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 1,
          stagger: enterStagger,
          overwrite: true,
        });
      }
    },

    onEnterBack: (batch) => {
      if (!checkVisited) {
        gsap.to(batch, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 1,
          stagger: backStagger,
          overwrite: true,
        });
        return;
      }

      const newItems: Element[] = [];
      const oldItems: Element[] = [];

      batch.forEach((el) => {
        if ((el as HTMLElement).dataset.animated) {
          oldItems.push(el);
        } else {
          newItems.push(el);
          (el as HTMLElement).dataset.animated = 'true';
        }
      });

      if (newItems.length > 0) {
        gsap.to(newItems, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 1,
          stagger: backNewStagger,
          overwrite: true,
        });
      }

      if (oldItems.length > 0) {
        gsap.to(oldItems, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 1,
          stagger: backStagger,
          overwrite: true,
        });
      }
    },

    onLeaveBack: (batch) => {
      if (!checkVisited) {
        gsap.to(batch, {
          ...initialState,
          overwrite: true,
        });
        return;
      }
      gsap.to(batch, {
        ...finalResetState,
        overwrite: true,
      });
    },

    onLeave: (batch) => {
      if (!checkVisited) {
        gsap.to(batch, {
          ...initialState,
          overwrite: true,
        });
        return;
      }
      gsap.to(batch, {
        autoAlpha: 0,
        overwrite: true,
      });
    },
  });
};
